/**
 * Csv Schema of Rastreamento
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Rastreamento} from '@/model/resource/Rastreamento'

/* TODO: review generated schema */
export class CsvRastreamentoSchema extends Schema {
  readonly name = 'CsvRastreamento'

  readonly fieldSet: FieldSet<Rastreamento> = {
    idRastreamentoPk: schema => schema.model.idRastreamentoPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    placa: schema => schema.model.placa,
    codigoViagem: schema => schema.model.codigoViagem,
    latitude: schema => schema.model.latitude,
    longitude: schema => schema.model.longitude,
    dataUltimaPosicao: schema =>
      Helper.datetime(schema.model.dataUltimaPosicao),
    endereco: schema => schema.model.endereco,
    numeroParadas: schema => schema.model.numeroParadas,
    codigoRastreioVeiculo: schema => schema.model.codigoRastreioVeiculo,
  }
}
